import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue";
import { ref } from 'vue';
import DropdownMenu from '@/components/DropdownMenu.vue';
import PureDropdownMenuItem from '@/components/PureDropdownMenuItem.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DropdownMenuItem',
    props: {
        icon: null,
        text: null
    },
    emits: ['click'],
    setup(__props, { emit }) {
        const opened = ref(false);
        const handleOpen = () => {
            opened.value = !opened.value;
        };
        function handleClick() {
            emit('click');
        }
        return (_ctx, _cache) => {
            return (!_ctx.$slots['submenu'])
                ? (_openBlock(), _createBlock(PureDropdownMenuItem, {
                    key: 0,
                    icon: __props.icon,
                    text: __props.text,
                    onClick: handleClick
                }, null, 8, ["icon", "text"]))
                : (_openBlock(), _createBlock(DropdownMenu, {
                    key: 1,
                    open: opened.value,
                    "onUpdate:open": _cache[0] || (_cache[0] = ($event) => ((opened).value = $event)),
                    placement: "right-start",
                    class: "w-full max-w-full",
                    indent: ""
                }, {
                    item: _withCtx(() => [
                        _createVNode(PureDropdownMenuItem, {
                            icon: __props.icon,
                            text: __props.text,
                            "show-sub-menu-arrow": "",
                            onClick: handleOpen
                        }, null, 8, ["icon", "text"])
                    ]),
                    "menu-items": _withCtx(() => [
                        _renderSlot(_ctx.$slots, "submenu")
                    ]),
                    _: 3
                }, 8, ["open"]));
        };
    }
});
